import { useState } from 'react';
import { CampaignOverviewMetrics } from '../components/CampaignOverviewMetrics/CampaignOverviewMetrics';
import { useAgencyCampaignContext } from '../agencyCampaignContext';
import { useCampaignParents } from '../useCampaignParents';
import { useShigoPermissions } from '../../auth/useShigoPermissions';
import { ShigoPermission } from '../../auth/permissions';
import { CampaignDetailsLayout } from '../CampaignDetailsLayout/CampaignDetailsLayout';
import { agencyDetailsLink, campaignListLink } from '../hierarchyLinks';
import { CampaignsTable } from '../campaigns/components/CampaignsTable';
import { BrandEditorDialog } from '../brands/components/BrandEditorDialog/BrandEditorDialog';

export function BrandDetailsPage({ brandId }: { brandId: string }) {
  const scope = useAgencyCampaignContext();
  const { brand } = useCampaignParents(brandId);
  const agency = scope?.agency ?? brand.data?.agency;
  const { can } = useShigoPermissions();
  const canWrite = Boolean(scope) || can(ShigoPermission.MadBuyCampaignWrite);
  const [editOpen, setEditOpen] = useState(false);
  return (
    <>
      <CampaignDetailsLayout
        name={brand.data?.name}
        loading={brand.isLoading}
        error={brand.isError || !brand.data}
        back={
          agency
            ? agencyDetailsLink(agency.id, scope?.agency.id)
            : campaignListLink(scope?.agency.id)
        }
        onEdit={
          canWrite
            ? () => {
                setEditOpen(true);
              }
            : undefined
        }
      >
        {brand.data ? (
          <>
            <CampaignOverviewMetrics filter={{ msBrandIds: [brandId] }} />
            <CampaignsTable key={brandId} parentBrand={brand.data} />
          </>
        ) : null}
      </CampaignDetailsLayout>
      {canWrite && editOpen && brand.data ? (
        <BrandEditorDialog
          brand={brand.data}
          parentAgency={agency ?? undefined}
          onClose={() => {
            setEditOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
